import React, { Fragment, useState, useEffect } from "react";
import { Button, Form, FormGroup, Label, Input, Row, Col } from "reactstrap";
import Calendar from "react-calendar";
import Select from "react-select";
import "react-calendar/dist/Calendar.css";
import "../../../style/calendarclass.css";
import moment from "moment";
import { Table, Checkbox } from "semantic-ui-react";
import {
  useEmpListAssignLeave,
  useForTableValues,
  useSelectedReward,
  RewardListAssignRewards,
  SelectedEmpAssignRewards,
  
} from "../../../components/adminSettings/index";
import TableWithSortPagtn from "../../../components/common/TableWithSortPagtn";
import api from "../../../apis/api";
var loginUser = JSON.parse(localStorage.getItem("user"));
let dayArr = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];

const FormAddAssignLeave = (props) => {
  const { inputFields, formValidation ,handleCheckCheckBox,WeekdayId ,departmentlist,leavetypelist,employeelist,handleSelectedEmp,isvisible,handleSelectAllEmp,IsAllSelected,selectedtype,selectedEmp,handleleaveChange,selectedoptions,curvalue,requestTypeList,handleonchangeType,Firstchoosengender,newnoofdaysperyaer,mappedEmployeeList} = props;
  const [calenderDate] = useState(new Date());
  let options=[];
  let options1=[];
  let options2=[];
  let holidaylist=[];
  const[requestType,setrequestType]=useState("");
  const [requesttypelist,setrequesttypelist]=useState([]);
  const [requesttypeName,setrequesttypeName]=useState("");
  const [emplist,setemplist]=useState([]);
  const [setId,setsetId] =useState("");
  const [thead] = useState([
    // "id",
    "Select",
    "Name",
   
    // "email",
    // "mobile",
    // "join date",
    // "role",
    // "action",
  ]);
  // holidaycal.map(function (hol){
  //   holidaylist.push(moment(hol.holidayDate).format('DD-MM-YYYY'));
  // })
   inputFields.map(function (desig) {
    if(desig.type=="multipleselect")
    {
      desig.option.map((el,i) =>{
        options.push({value: el.departmentId, label: el.departmentName }); 
      })
     
    }
  })
  let employeelistn=employeelist;

    const { trow } = useEmpListAssignLeave(emplist.length > 0 ? emplist : employeelistn, handleSelectedEmp,IsAllSelected,selectedEmp,mappedEmployeeList);
  
  
  const onChangeType = (requesttypeid,requesttype) => {
    const fetchApi = async () => {
      setrequestType(requesttypeid);
      setrequesttypeName(requesttype);
      let array=[];
      if(requesttype=="Duty")
      {
        await api.dbLeaveTypes().GetAllDutyTypes().then((res) => array.push(res.data))
      }
      else
      {
        await api.dbLeaveTypes().GetAllLeaveTypes().then((res) => array.push(res.data))
      }
     ;
      // setEmpData(array[0]);
      // setempArr(array[0]);
      setrequesttypelist(array[0]);
      props.handleonchangeType(requesttypeid);
    }
    
    fetchApi();
  }
  const searchEmployee = React.useCallback(
    (searchVal) => {
      let searchArr = employeelistn.filter(
        (el) =>
          el.employeeName.toLowerCase().indexOf(searchVal.toLowerCase()) !== -1
      );
      setemplist(searchArr);
    },
    [employeelistn]
  );
  const users = [
    {id: 1, name: 'Sunday'},
    {id: 2, name: 'Monday'},
    {id: 3, name: 'Tuesday'},
    {id: 4, name: 'Wednesday'},
    {id: 5, name: 'Thursday'},
    {id: 6, name: 'Friday'},
    {id: 7, name: 'Saturday'},
  ];
  
  const TableRow = React.memo(({ selected, id, label,employeetype,leave,gender,curvalue,disabled }) => {
   
    const currentindex=selected.findIndex((item,i) => item.id === String(id));
    return (
      <Table.Row>
        <Table.Cell>
          <input type="checkBox"
            id={id}
             checked={selected.findIndex((item) => item.id ===String(id)) !== -1 ? true :false} 
            onChange={(e) => {
              handleCheckCheckBox(e.target.id,0,leave,gender,e);
            }}
            disabled={disabled}
          />
        </Table.Cell>
        <Table.Cell>{label}({employeetype} )</Table.Cell>
        
        <Table.Cell><input type="text" value={selected.length > 0 ? (currentindex === -1 ? leave :(curvalue === selected[currentindex].id ? ((leave === selected[currentindex].leave) ? leave : selected[currentindex].leave) :leave ) ) : leave} name={label} 
        onChange={(evnt)=> (handleleaveChange(id, evnt.target.value))}></input></Table.Cell>
        {/* <Table.call>{leave}</Table.call> */}
      </Table.Row>
    );
  })
  return (
    <Fragment>
 
        <Row>
          <Col md={6}>
            <Label>Request Type</Label>
      <Input type="select" name="requestTypeId" className="form-control"  onChange={(e) =>{for (let node of e.target.children) {
              if (node.value === e.target.value) {
                onChangeType(e.target.value,node.getAttribute('data-id'))
               
              }
            }} } value={requestType}>
                        <option value={0}>Select Request Type</option>
                        {requestTypeList.map((request, i) => (
                        <option
                        key={i}
                        value={request.requestTypeId}   
                        data-id={request.requestType}   
                        // selected={
                        //     data.rating == request.requestTypeId ? true : false
                        //   }                     
                        >
                        {request.requestType}
                        </option>
                       ))}    
                    </Input> 
                    </Col>
      </Row>
      <br/>
      {requestType !="" ?(<Row form>
       
          
          
          <Col md={4}>

          <Table>
      <Table.Header>
      <Table.Row>
        <Table.HeaderCell />
        <Table.HeaderCell>Leave/Duty Type</Table.HeaderCell>
      </Table.Row>
      </Table.Header>
      {requesttypeName == "Duty" ? (<Table.Body>
          {requesttypelist.map((user) => 
              <TableRow 
                key={user.dutyTypeId} 
                id={user.dutyTypeId}
                label={user.type}  
                gender ={user.gender}
                leave={user.noOfDaysPerYear}
                selected={selectedtype}
                curvalue={curvalue}
              />
          )}
      </Table.Body>) : (<Table.Body>
          {requesttypelist.map((user) => 
              <TableRow 
                key={user.leaveTypeId} 
                id={user.leaveTypeId}
                label={user.type}  
                employeetype={user.employeeTypeValue}  
                leave={user.noOfLeavesPerYear}
                gender ={user.gender}
                selected={selectedtype}
                curvalue={curvalue}
                disabled={Firstchoosengender=='' ? (false) : (user.gender == Firstchoosengender ? false : true)}
              />
          )}
      </Table.Body>)}
      
    </Table>
          </Col>
          <Col md={8}>

          {inputFields !== undefined
        ? inputFields.map((val, i) => {
              return (
              <FormGroup key={i} >
                <Label sm={3}>{val.label}</Label>
                {/* if input field is a text or number then */}
                {val.type === "text"? (
                   
                  <Input
                    type={val.type}
                    placeholder={val.placeholder}
                    onChange={(e) => {
                      val.handleOnChange(e.target.value);
                    }}   
                    value={props.formval}  
                  />
              ) : null}
                {val.type === "number" ? (
                 
                  <Input
                    type={val.type}
                    placeholder={val.placeholder}
                    onChange={(e) => {
                      val.handleOnNumberChange(e.target.value);
                    }}   
                  />
                ) : null}
              
                {val.type === "file" ? (
                  
                  <Input
                    type={val.type}
                    placeholder={val.placeholder}
                    onChange={(e) => {

                      val.handleOnChange(e);
                    }}
                    // value={props.formData ? props.formData.val[val.name] : null}
                  /> 
                ) : null}
                { val.type === "select" ? (
                 
                  <Fragment>
                   
                    <Input
                      type={val.type}
                      placeholder={val.placeholder}
                      onChange={(e) => {
                        val.handleOnChange(e.target.value);
                      }}
                    >
                      <option value="0">----Select----</option>
                      {val.option.map((el, i) => (
                       <option 
                        key={i} 
                        value={el[val.displayData["id"]]}
                        >
                          {el[val.displayData["selectedData"]]}
                        </option>
                      ))}
                    </Input>
                    
                  </Fragment>
                ) : null}

            
           
             {val.type === "checkbox"? (
                   
                  <Input
                    type={val.type}
                    placeholder={val.placeholder}
                    onChange={(e) => {
                      handleSelectedEmp(e.target.value,0,requesttypelist);
                    }}   
                    value={props.formval}  
                  />
               ) : null}

                { val.type === "multipleselect" && val.option.length >0 ? (
                 
                 <Fragment>

          <Select style={{color:"black"}}
        isMulti  options={options} value={selectedoptions} defaultValue={ selectedoptions.map(ele => ele) }  onChange={(e) => {
          val.handleOnChange(e == null ? 0 : e[e.length-1].value,0,e);
        }}>
           
         
          </Select>
                 </Fragment>
               ) : null}
               
                {Object.keys(formValidation)?.length !== 0 &&
                  !formValidation?.[val.name]?.isValid && (
                    <span className=" " style={{ color: "red" }}>
                      {formValidation?.[val.name]?.errorMessage}
                    </span>
                  )}
              </FormGroup>
            );
          })
        : null}

              
         {employeelist.length > 0 ? ( <Row>
              <Col>
              <div> 
              <Col>
              <Row>
              <Col>
              <Label check className="check-select-all">
                <Input type="checkbox" onChange={handleSelectAllEmp}/>
                Select All
              </Label>
              </Col>
              <Col>
                <Input
                  type="text"
                  className="d-inline"
                  placeholder="Search Employee...."
                  onChange={(e) => searchEmployee(e.target.value)}
                /> 
              </Col>
              </Row>
              <Col> 
              <TableWithSortPagtn
                thead={thead}
                trow={trow}
                pageSize={5}
              ></TableWithSortPagtn>
              </Col>
             
              
              
              </Col>
            
            </div>
              </Col>


            </Row>) : null}   
            <Button color="" onClick={props.handleSubmit} className="btn-admin-settings">
              Assign
            </Button>{" "}
            &nbsp;
            {/* <Button color="" className="btn-cancel" onClick={props.toggle}>
              cancel
            </Button> */}
          </Col>
        </Row>): null}
      

    </Fragment>
  );
};

export default FormAddAssignLeave;
